import React from 'react';
import { Link } from 'react-router-dom';

import './index.scss';

import { onKeyDownFunc } from 'utils';

const PrevButton = ({ label = '戻る', onClick = () => {}, link }) => {
   
  const onClickFunc = (e) => {
    onClick(e);
  };

  return (
    <Link
      to={link}
      className="PrevButton"
      onKeyDown={onKeyDownFunc}
    >
      <button
        className="button"
        type="button"
        onClick={onClickFunc}
      >
        {label}
      </button>
    </Link>
  );
};

export default PrevButton;